// @flow

import * as React from 'react';

import { useDispatch } from 'react-redux';

import {
  updateProductAndGetCartOrNotify,
  selectOneProductErrors,
} from '@gandi/cart';

import type { DecoratedProduct } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import { useAppSelector } from 'src/hooks';

import ProductErrorItem from './components/ProductErrorItem';
import ProductItem from './components/ProductItem';
import { DurationRow } from './components/Rows';

import type { GandiFormSelectOption } from './types';

type Props = { product: DecoratedProduct };

const durationUnit = 'm';
const durations = [1, 3, 12];

export function CorporateCreate({ product }: Props): React.MixedElement {
  const { __ } = useTranslator();
  const dispatch = useDispatch();

  const productErrors = useAppSelector(state =>
    selectOneProductErrors(state, {
      productId: product.id,
    }),
  );

  const handleDurationChange: (
    selectOption: GandiFormSelectOption<string>,
  ) => void = (selectOption: GandiFormSelectOption<string>) => {
    const newPayload = {
      ...product.payload,
      duration: parseInt(selectOption.value, 10),
    };

    dispatch(updateProductAndGetCartOrNotify(__, product.id, newPayload));
  };

  const label = __('Corporate Pack');
  const detail = __('Temporary subscription to buy corporate extensions');

  if (productErrors.length > 0)
    return (
      <ProductErrorItem
        key={`${product.id}-error-row`}
        detail={detail}
        label={label}
        productId={product.id}
        deleteDisabled
        errors={productErrors}
      />
    );

  const showDurations = !productErrors.length;
  return (
    <ProductItem
      key={`${product.id}-row`}
      hasTaxes={product.hasTaxes}
      priceBeforeTaxes={
        product.isWorking ? undefined : product.total?.before_taxes
      }
      deleteDisabled
      productId={product.id}
      label={label}
      detail={detail}
    >
      <DurationRow
        productId={product.id}
        showOption={showDurations}
        disabledOption={!showDurations || !!product.isWorking}
        value={product.payload.duration || 1}
        // $FlowFixMe[incompatible-type-arg] - number is number|string
        onChange={handleDurationChange}
        unit={durationUnit}
        values={durations}
        total={product.isWorking ? undefined : product.unitPrice}
      />
    </ProductItem>
  );
}
